import React from 'react';

import styled from 'styled-components';
import {inject} from 'mobx-react';
import { isIE11OrEdge } from '../../helpers/browser-detection';

const Animated = styled.img `
    @-webkit-keyframes fadeFromRight {
        from {
            opacity: 0;
            -webkit-transform: translate3d(5%, 0, 0);
            transform: translate3d(5%, 0, 0);
        }  
        to {
            opacity: 1;
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }
    }

    @keyframes fadeFromRight {
        from {
            opacity: 0;
            -webkit-transform: translate3d(5%, 0, 0);
            transform: translate3d(5%, 0, 0);
        }  
        to {
            opacity: 1;
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }
    }

    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    -webkit-animation-name: fadeFromRight;
    animation-name: fadeFromRight;

    height: 100%;
`;

const Components = {
    default: (props) => <Animated {...props} />,
    fix: ({alt, ...props}) => <img {...props} alt={alt} />
}

const mapper = (stores) => ({
    intl: stores.intl.dictionary,
    character: stores.characters.character,
})

export default inject(mapper)(({character: { id, src, aria } = {}, intl = {}}) => {
    let Component = Components['default'];

    if (isIE11OrEdge()) Component = Components['fix'];

    let width = null, right = null;
    if (id === 2) {
        width = `calc(125% + ${25 * 6}px)`;
        right = `-${25 * 6.5}px`;
    };
    if (id === 3) {
        width = `calc(110% + ${25 * 6}px)`;
        right = `-${25 * 6}px`;
    };

    let KEY = `character-image-${id}`;

    return (
        <div className="col-md-6 character-image">
            <Component   
                key={KEY}
                src={src}
                alt={intl[aria.altImgData]}
                title={intl[aria.altImgData]}
                style={{ width, right }} />
        </div>
    )
})